module.exports = __webpack_public_path__ + "static/media/wolffox6.4e8ee52a.jpg";